import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as keyCodes from "../../../constants/keyCodes";
import * as config from "../../../constants/config";
import * as settings from "../../../constants/settings";
import * as resources from "../../../constants/resources";
import * as validationHelper from "../../../helpers/validationHelper";
import * as conversionHelper from "../../../helpers/conversionHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import ColorantBoxes from "./quickTint/ColorantBoxes";
import Modal from "../generic/Modal";
import Button from "../generic/Button";
import ArrowButton from "../../apps/gamma/global/ArrowButton";

export default class QuickTintModalGamma extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedColorants: [],
            selectedUnit: this.props.unit,
            activeColorantRow: null
        };
    }

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleSelectColorantClick = (event) => {
        let colorant = this.getColorantFromList(event.target.dataset.id);
        if (this.state.selectedUnit === settings.UNIT_SHOT) {
            colorant.amountType = this.props.shotsName;
        }
        if (this.state.selectedUnit === settings.UNIT_G) {
            colorant.amountType = settings.UNIT_G;
        }
        if (colorant !== null) {
            this.setState({
                selectedColorants: [...this.state.selectedColorants, colorant]
            });
        }
    };

    handleRemoveColorantClick = (event) => {
        let colorant = this.getColorantFromSelectedList(event.currentTarget.dataset.id);

        if (colorant !== null) {
            this.setState({selectedColorants: this.getFilteredSelectedColorants(colorant)});
        }
    };

    handleColorantValueChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeColorantValue(event.target.dataset.id, validationHelper.formatDecimal(event.target.value));
        }
    };

    handleColorantValueFocus = (event) => {
        event.target.select();
        this.setState({
            activeColorantRow: event.target.dataset.id
        });
    };

    handleColorantValueBlur = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeColorantValue(
                event.target.dataset.id,
                Number(validationHelper.formatDecimal(event.target.value))
            );
        }
        this.setState({
            activeColorantRow: null
        });
    };

    handleMinusClick = (event) => {
        let changedColorant = this.getColorantFromSelectedList(event.currentTarget.dataset.id);

        if (changedColorant !== null) {
            let colorantAmount = changedColorant.amount - 0.2;

            if (colorantAmount >= 0) {
                this.changeColorantValue(event.currentTarget.dataset.id, Math.round(colorantAmount * 10) / 10);
            }
        }
    };

    handlePlusClick = (event) => {
        let changedColorant = this.getColorantFromSelectedList(event.currentTarget.dataset.id);

        if (changedColorant !== null) {
            let colorantAmount = changedColorant.amount + 0.2;

            if (colorantAmount >= 0) {
                this.changeColorantValue(event.currentTarget.dataset.id, Math.round(colorantAmount * 10) / 10);
            }
        }
    };

    handleDatabaseClick = (event) => {
        this.setState({
            selectedColorants: []
        });
        this.props.setActiveDatabase(event.currentTarget.dataset.database);
    };

    getFilteredSelectedColorants = (filteredColorant) => {
        return this.state.selectedColorants.filter(
            (colorant) => colorant.id + "-" + colorant.name !== filteredColorant.id + "-" + filteredColorant.name
        );
    };

    getFirstSelectedColorantId = () => {
        if (this.state.selectedColorants.length > 0) {
            return this.state.selectedColorants[0].id;
        }
        return null;
    };

    getNextSelectedColorantId = (colorantKey) => {
        let index;
        for (index = 0; index < this.state.selectedColorants.length; index++) {
            if (
                this.state.selectedColorants[index].id + "-" + this.state.selectedColorants[index].name ===
                colorantKey
            ) {
                if (index + 1 < this.state.selectedColorants.length) {
                    return this.state.selectedColorants[index + 1].id;
                }
                return null;
            }
        }
        return null;
    };

    changeColorantValue = (colorantKey, value) => {
        let changedColorant = this.getColorantFromSelectedList(colorantKey);

        if (changedColorant !== null) {
            this.setState({
                selectedColorants: this.state.selectedColorants.map((colorant) => {
                    if (colorant.id + "-" + colorant.name === colorantKey) {
                        return changedColorant.updateAmount(value);
                    }

                    return colorant;
                })
            });
        }
    };

    getColorantFromList = (colorantKey) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.colorant !== null && canister.colorant.id + "-" + canister.colorant.name === colorantKey) {
                return canister.colorant.clone();
            }
        }

        let colorant;
        for (colorant of this.props.colorantList) {
            if (colorant.id + "-" + colorant.name === colorantKey) {
                return colorant.clone();
            }
        }

        return null;
    };

    getColorantFromSelectedList = (colorantId) => {
        let selectedColorant;
        for (selectedColorant of this.state.selectedColorants) {
            if (selectedColorant.id + "-" + selectedColorant.name === colorantId) {
                return selectedColorant;
            }
        }

        return null;
    };

    getActiveColorantAmount = (selectedColorant) => {
        if (selectedColorant.id + "-" + selectedColorant.name === this.state.activeColorantRow) {
            return selectedColorant.amount;
        }
        return selectedColorant.formatAmount();
    };

    getSelectedColorantRows = () => {
        let rows = [];

        let selectedColorant, canister, rgb;

        for (selectedColorant of this.state.selectedColorants) {
            canister = this.getCanisterByColorant(selectedColorant);
            rgb = this.getCanisterRgb(canister, selectedColorant);

            rows.push(
                <div
                    key={selectedColorant.id + "-" + selectedColorant.name}
                    className="width-100per flex font-2_5vh line-height-3_7vh std-border-bottom flex-align-center"
                >
                    <div className="col-5 color-primary font-3_5vh flex flex-align-center-vertical">
                        <div className="color-square" style={{backgroundColor: rgb, height: "2.5vh", width: "2.5vh"}} />
                        <div>{selectedColorant.name}</div>
                    </div>
                    <div className="col-4 flex height-100per padding-top-5 padding-bottom-5 flex-align-center-vertical">
                        <Button
                            label={"-"}
                            className="svg-only-btn full-height-btn"
                            onClick={this.handleMinusClick}
                            elementProps={{
                                "data-id": selectedColorant.id + "-" + selectedColorant.name
                            }}
                        />
                        <input
                            id={"quick-tint-colorant-" + selectedColorant.id}
                            type="text"
                            className="text-right height-100per min-width-150"
                            value={this.getActiveColorantAmount(selectedColorant)}
                            data-id={selectedColorant.id + "-" + selectedColorant.name}
                            onFocus={this.handleColorantValueFocus}
                            onBlur={this.handleColorantValueBlur}
                            onChange={this.handleColorantValueChange}
                            onKeyDown={this.handleColorantValueKeyDown}
                        />
                        <Button
                            label={"+"}
                            className="svg-only-btn full-height-btn"
                            onClick={this.handlePlusClick}
                            elementProps={{
                                "data-id": selectedColorant.id + "-" + selectedColorant.name
                            }}
                        />
                        <span className="amount-type margin-left-10">{selectedColorant.amountType}</span>
                    </div>
                    <div className="col-3 flex flex-end padding-top-5 padding-bottom-5">
                        <Button
                            label={translate("general.delete")}
                            onClick={this.handleRemoveColorantClick}
                            elementProps={{
                                "data-id": selectedColorant.id + "-" + selectedColorant.name
                            }}
                        />
                    </div>
                </div>
            );
        }

        return rows;
    };

    getCanisterByColorant = (colorant) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                return canister;
            }
        }

        return null;
    };

    getCanisterRgb = (canister, colorant) => {
        if (canister !== null && canister.colorant !== null && canister.colorant.rgb !== null) {
            return canister.colorant.rgb;
        }

        if (colorant.rgb !== null) {
            return colorant.rgb;
        }

        return config.DEFAULT_RGB;
    };

    handlePrintKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB) {
            event.preventDefault();
            window.jQuery("#quick-tint-dispensing").focus();
        }
    };

    handleDispensingKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB) {
            event.preventDefault();
            let firstColorant = this.getFirstSelectedColorantId();
            if (firstColorant !== null) {
                window.jQuery("#quick-tint-colorant-" + firstColorant).focus();
            } else {
                window.jQuery("#quick-tint-print").focus();
            }
        }
    };

    handleColorantValueKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB) {
            event.preventDefault();
            let nextColorant = this.getNextSelectedColorantId(event.currentTarget.dataset.id);
            if (nextColorant === null) {
                window.jQuery("#quick-tint-print").focus();
            } else {
                window.jQuery("#quick-tint-colorant-" + nextColorant).focus();
            }
        }
    };

    getFormulaObject = () => {
        let formula = modelHelper.mapFormulaToObject(
            config.QUICK_TINT_ID,
            config.QUICK_TINT_ID,
            config.QUICK_TINT_NAME,
            translate("general.quickTint"),
            config.QUICK_TINT_NAME
        );

        if (this.state.selectedUnit === settings.UNIT_SHOT) {
            formula.colorantListShot = this.state.selectedColorants;
            return formula.updateColorantsMlByShots(this.props.shotsCoef);
        }

        if (this.state.selectedUnit === settings.UNIT_G) {
            formula.colorantListG = this.state.selectedColorants;
            return formula.updateColorantsMlByG(this.props.shotsCoef);
        }

        formula.colorantList = this.state.selectedColorants;

        return formula;
    };

    handlePrintButtonClick = () => {
        this.props.quickPrint(
            validationHelper.getValidItem(this.props.printerList, this.props.selectedPrinter),
            validationHelper.getValidItem(this.props.templateList, this.props.templateName),
            this.getFormulaObject(),
            this.props.unit
        );
    };

    handleUnitChange = (event) => {
        let newColorants = [];

        let colorant;
        for (colorant of this.state.selectedColorants) {
            newColorants.push(
                colorant.updateAmountValues(
                    conversionHelper.convertAmountByColorant(
                        colorant,
                        this.state.selectedUnit,
                        event.target.value,
                        this.props.shotsCoef
                    ),
                    event.target.value === settings.UNIT_SHOT ? this.props.shotsName : event.target.value
                )
            );
        }

        this.setState({
            selectedColorants: newColorants,
            selectedUnit: event.target.value
        });
    };

    handleDispensingClick = () => {
        this.props.startQuickDispense(this.getFormulaObject());
    };

    areColorantsValid = () => {
        if (this.state.selectedColorants.length === 0) {
            return false;
        }

        let colorant;
        for (colorant of this.state.selectedColorants) {
            if (colorant.amount <= 0) {
                return false;
            }
        }

        return true;
    };

    getPrintButton = () => {
        if (!this.props.printOnRequest || this.props.loggedUser.canNotRead(resources.FUNCTION_PRINT)) {
            return "";
        }

        if (
            this.areColorantsValid() &&
            this.props.dispensingFormula === null &&
            !this.props.dispensingInProgress &&
            this.props.connectedRcc &&
            this.props.machine.isConnected &&
            this.maximumValueValidation()
        ) {
            return (
                <ArrowButton
                    id="quick-tint-print"
                    label={<Translate value="general.print" />}
                    elementProps={{
                        onKeyDown: this.handlePrintKeyDown
                    }}
                    onClick={this.handlePrintButtonClick}
                />
            );
        }

        return "";
    };

    getQuickDispensingButton = () => {
        if (this.props.loggedUser.canNotRead(resources.FUNCTION_DISPENSING)) {
            return "";
        }

        if (
            this.areColorantsValid() &&
            this.props.dispensingFormula === null &&
            !this.props.dispensingInProgress &&
            this.props.connectedRcc &&
            this.props.machine.isConnected &&
            this.maximumValueValidation()
        ) {
            return (
                <ArrowButton
                    id="quick-tint-dispensing"
                    label={<Translate value="general.dispense" />}
                    className="margin-left-10"
                    elementProps={{
                        onKeyDown: this.handleDispensingKeyDown
                    }}
                    onClick={this.handleDispensingClick}
                />
            );
        }

        return "";
    };

    getUnitsSelectBox = () => {
        let units = [];

        if (this.props.visibleUnits.ml || this.props.unit === settings.UNIT_ML) {
            units.push(
                <option key={settings.UNIT_ML} value={settings.UNIT_ML}>
                    {settings.UNIT_ML}
                </option>
            );
        }
        if (this.props.visibleUnits.g || this.props.unit === settings.UNIT_G) {
            units.push(
                <option key={settings.UNIT_G} value={settings.UNIT_G}>
                    {settings.UNIT_G}
                </option>
            );
        }
        if (this.props.visibleUnits.shots || this.props.unit === settings.UNIT_SHOT) {
            units.push(
                <option key={settings.UNIT_SHOT} value={settings.UNIT_SHOT}>
                    {settings.UNIT_SHOT}
                </option>
            );
        }

        if (units.length > 1) {
            return (
                <select className="min-width-150" value={this.state.selectedUnit} onChange={this.handleUnitChange}>
                    {units}
                </select>
            );
        }

        return "";
    };

    maximumValueValidation = () => {
        let canister, colorant;
        for (colorant of this.state.selectedColorants) {
            for (canister of this.props.canisterList) {
                if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                    if (this.state.selectedUnit === settings.UNIT_ML) {
                        if (colorant.amount > canister.capacityMl || colorant.amount <= 0) {
                            return false;
                        }
                    }
                    if (this.state.selectedUnit === settings.UNIT_G) {
                        if (colorant.density === 0) {
                            return false;
                        }
                        if (
                            colorant.amount / colorant.density > canister.capacityMl ||
                            colorant.amount / colorant.density <= 0
                        ) {
                            return false;
                        }
                    }
                    if (this.state.selectedUnit === settings.UNIT_SHOT) {
                        if (
                            colorant.amount * this.props.shotsCoef > canister.capacityMl ||
                            colorant.amount * this.props.shotsCoef <= 0
                        ) {
                            return false;
                        }
                    }
                }
            }
        }

        return true;
    };

    getDatabaseButtons = () => {
        let buttonList = [];

        for (let database of this.props.databaseList) {
            if (this.props.activeDatabase.name === database.name) {
                buttonList.push(
                    <Button
                        key={database.uuid}
                        className="primary-btn background-darker-blue cursor-auto"
                        label={database.name}
                    />
                );
            } else {
                buttonList.push(
                    <Button
                        key={database.uuid}
                        className="primary-btn"
                        elementProps={{
                            key: database.uuid,
                            "data-database": database.name
                        }}
                        label={database.name}
                        onClick={this.handleDatabaseClick}
                    />
                );
            }
        }

        return buttonList;
    };

    getSelectedDatabase = () => {
        if (this.props.databaseList.length <= 1 || this.props.activeDatabase === null) {
            return null;
        }

        return modelHelper.buildModalSection(
            <div className="width-100per font-3vh flex">
                <div className="col-3 flex flex-align-center-vertical">Selected brand</div>
                <div className="col-9 flex flex-align-center-vertical flex-gap-3vh">{this.getDatabaseButtons()}</div>
            </div>
        );
    };

    getContent = () => {
        if (!this.props.rccModule) {
            return modelHelper.buildModalSection(<Translate value="general.rccNotLicensed" />);
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="width-100per height-50per flex flex-column slim-scroll">
                    {this.getSelectedColorantRows()}
                </div>
                <ColorantBoxes
                    loggedUser={this.props.loggedUser}
                    activeDatabase={this.props.activeDatabase}
                    selectedColorants={this.state.selectedColorants}
                    allowCanisterColorants={true}
                    canisterList={this.props.canisterList}
                    colorantList={this.props.colorantList}
                    databaseColorantList={this.props.databaseColorantList}
                    sorting={this.props.sorting}
                    spaceInPackage={null}
                    handleSelectColorantClick={this.handleSelectColorantClick}
                />
            </React.Fragment>,
            "flex flex-column height-100per"
        );
    };

    getFooter = () => {
        if (!this.props.rccModule) {
            return null;
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="color-black bold margin-right-auto flex fill-flex-space flex-align-center-vertical font-2_5vh flex-gap-10px">
                    <Translate value="modal.changeColorantUnit" />
                    {this.getUnitsSelectBox()}
                </div>
                {this.getPrintButton()}
                {this.getQuickDispensingButton()}
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.quickTint" />)}
                subHeader={this.getSelectedDatabase()}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    width: "70%",
                    height: "80%"
                }}
            />
        );
    }
}
